import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'second-collection',
  templateUrl: './second-collection.component.html',
  styleUrls: ['./second-collection.component.scss'],
})
export class SecondCollectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
